import { ImageGrid } from 'components/ImageGrid';
import { pureComponent } from 'lib/pureComponent';
import { theme } from 'lib/theme';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { FilesContext, FilesContextEnum } from 'types/types';
import { API_ASE_IMAGE } from 'service/api/constants';
import { useSelector } from 'hooks/useSelector';
import { selectUrlToken } from 'store/auth/selectors';
import { useDispatch } from 'react-redux';
import { doFileDownload, doFilePreview } from 'store/actions';
import { FileTypeExtensions } from 'service/file/types';

type Props = {
  value: string[];
  context: FilesContext;
};

export const ImageDisplay: React.FC<Props> = pureComponent(
  ({ value, context }) => {
    const dispatch = useDispatch();

    const urlToken = useSelector(selectUrlToken);

    const handlePreview = React.useCallback(
      (fileId: string) => {
        dispatch(
          doFilePreview({
            fileId,
            typeId: FileTypeExtensions.jpeg,
            context,
          }),
        );
      },
      [context, dispatch],
    );

    const handleDownload = React.useCallback(
      (fileId: string) => {
        dispatch(
          doFileDownload({
            fileId,
            typeId: FileTypeExtensions.jpeg,
            context,
          }),
        );
      },
      [context, dispatch],
    );

    if (!value.length) {
      return null;
    }

    return (
      <View style={{ backgroundColor: 'white', padding: 2 }}>
        <View style={styles.imageGridContainer}>
          <ImageGrid
            ids={value}
            onPreview={handlePreview}
            onDownload={handleDownload}
            remoteUrl={
              context.context === FilesContextEnum.remoteAssessment
                ? API_ASE_IMAGE(context.assessmentId, { urlToken })
                : undefined
            }
          />
        </View>
      </View>
    );
  },
);

const styles = StyleSheet.create({
  buttonsContainer: {
    backgroundColor: 'white',
    paddingLeft: theme.padding - 4,
    height: 50,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  imageGridContainer: {
    backgroundColor: 'white',
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
});
